
























































































































import {Component, Emit, Vue} from 'vue-property-decorator';
import {Mall} from '@/views/claim/dataType/OrderProductOption';
import {ComponentItemsClaimDataType, ClaimableOption} from '@/views/claim/components/dataType/ComponentDataType';
import {
  PostReturnsPredictRequest,
  PostReturnsRequest,
  GetClaimsOrderOptionsOrderOptionNoApplyRequest,
  GetClaimsOrderOptionsOrderOptionNoApply,
  RefundType
} from 'supporter';
import ComponentNoticeBox from '@/views/claim/components/ComponentNoticeBox.vue';
import ComponentItemsClaim from '@/views/claim/components/ComponentItemsClaim.vue';
import ComponentReturnAddress from '@/views/claim/components/ComponentReturnAddress.vue';
import ComponentReturnShippingFee from '@/views/claim/components/ComponentReturnShippingFee.vue';
import ComponentDiscountShippingFee from '@/views/claim/components/ComponentDiscountShippingFee.vue';
import ComponentProductDetails from '@/views/claim/components/ComponentProductDetails.vue';
import ComponentRefundExchangeAmount from '@/views/claim/components/ComponentRefundExchangeAmount.vue';
import ComponentBenefitsPaid from '@/views/claim/components/ComponentBenefitsPaid.vue';
import {addClass} from '@/utils/classUtils';
@Component({
  components: {ComponentNoticeBox, ComponentItemsClaim, ComponentDiscountShippingFee, ComponentReturnAddress, ComponentReturnShippingFee, ComponentProductDetails, ComponentRefundExchangeAmount, ComponentBenefitsPaid}
})
export default class ReturnPopup extends Vue {
  @Emit('defaultPredict')
  private defaultPredict() {
    this.postReturnsPredict = {
      refundType: 'ACCOUNT',
      shipping: {
        requiresShipping: false,
        address: {
          address: '',
          name: '',
          jibunAddress: '',
          detailAddress: '',
          zipCd: '',
          contact1: '',
          contact2: '',
        },
        shippingNo: 0,
        hasAdjustedExchangeDeliveryAmt: false,
        divided: false,
        deliveryGroupNo: 0,
        deliveryType: '',
        prepaid: false,
        deliveryTemplateNo: 0,
        combined: false,
        originalShippingNo: 0,
      },
      coupon: {
        productCoupons: [{
          couponName: '',
          couponIssueNo: 0,
          orderProductNo: 0,
          restores: false,
          couponNo: 0,
        }],
        cartCoupon: {
          couponName: '',
          couponIssueNo: 0,
          orderProductNo: 0,
          restores: false,
          couponNo: 0,
        },
      },
      amounts: {
        returnDelivery: {
          totalReturnDeliveryAmt: 0,
          totalPureReturnDeliveryAmt: 0,
          prepaidTotalPureReturnDeliveryAmt: 0,
          prepaidProcessedDeliveryAmt: 0,
          returnRemoteDeliveryAmt: 0,
          returnDeliveryAmt: 0,
          prepaidReturnRemoteDeliveryAmt: 0,
          processedDeliveryAmt: 0,
          prepaid: false,
          prepaidTotalReturnDeliveryAmt: 0,
          prepaidReturnDeliveryAmt: 0,
        },
        deliveryAdjustAmt: 0,
        returnDeliveryAdjustAmt: 0,
        adjustedAmounts: {
          mainPayAmt: 0,
          accumulationPayAmt: 0,
          claimAmt: 0,
          additionalPayAmt: 0,
          payAmt: 0,
        },
        before: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0,
              alreadyPaidTotalDeliveryAmt: 0,
            },
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0,
          },
          accumulation: {
            accumulationAmt: 0,
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0,
          },
        },
        after: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0,
              alreadyPaidTotalDeliveryAmt: 0,
            },
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0,
          },
          accumulation: {
            accumulationAmt: 0,
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0,
          },
        },
        refund: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0,
              alreadyPaidTotalDeliveryAmt: 0,
            },
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0,
          },
          accumulation: {
            accumulationAmt: 0,
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0,
            totalDeliveryAmt: 0,
          },
        },
      },
      overflowsPgAmt: false,
    };
  }
  private refundType: string = '';
  private showA: boolean = false;
  private showB: boolean = false;
  private displayedDeliveryAmtDiscountMessage: boolean = false;
  private pageName = 'ReturnPopup';
  private isShow: boolean = false;
  private mall: Mall = {
    countryCd: 'KR'
  };
  private orderOptionsApply: ComponentItemsClaimDataType = {
    orderNo: '',
    claimableOptions: [],
    refundTypes: [],
    payType: ''
  };
  private postReturnsPredict = {
    refundType: 'ACCOUNT',
    shipping: {
      requiresShipping: false,
      address: {
        address: '',
        name: '',
        jibunAddress: '',
        detailAddress: '',
        zipCd: '',
        contact1: '',
        contact2: '',
      },
      shippingNo: 0,
      hasAdjustedExchangeDeliveryAmt: false,
      divided: false,
      deliveryGroupNo: 0,
      deliveryType: '',
      prepaid: false,
      deliveryTemplateNo: 0,
      combined: false,
      originalShippingNo: 0,
    },
    coupon: {
      productCoupons: [{
        couponName: '',
        couponIssueNo: 0,
        orderProductNo: 0,
        restores: false,
        couponNo: 0,
      }],
      cartCoupon: {
        couponName: '',
        couponIssueNo: 0,
        orderProductNo: 0,
        restores: false,
        couponNo: 0,
      },
    },
    amounts: {
      returnDelivery: {
        totalReturnDeliveryAmt: 0,
        totalPureReturnDeliveryAmt: 0,
        prepaidTotalPureReturnDeliveryAmt: 0,
        prepaidProcessedDeliveryAmt: 0,
        returnRemoteDeliveryAmt: 0,
        returnDeliveryAmt: 0,
        prepaidReturnRemoteDeliveryAmt: 0,
        processedDeliveryAmt: 0,
        prepaid: false,
        prepaidTotalReturnDeliveryAmt: 0,
        prepaidReturnDeliveryAmt: 0,
      },
      deliveryAdjustAmt: 0,
      returnDeliveryAdjustAmt: 0,
      adjustedAmounts: {
        mainPayAmt: 0,
        accumulationPayAmt: 0,
        claimAmt: 0,
        additionalPayAmt: 0,
        payAmt: 0,
      },
      before: {
        delivery: {
          deliveryAmt: 0,
          remoteDeliveryAmt: 0,
          totalDeliveryAmt: 0,
          deliveryGroupAmounts: {
            prepaidRemoteDeliveryAmt: 0,
            payOnRemoteDeliveryAmt: 0,
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            payOnDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            prepaidDeliveryAmt: 0,
            totalPrepaidDeliveryAmt: 0,
            alreadyPaidTotalDeliveryAmt: 0,
          },
        },
        coupon: {
          cartCouponDiscountAmt: 0,
          productCouponDiscountAmt: 0,
        },
        accumulation: {
          accumulationAmt: 0,
        },
        order: {
          immediateDiscountAmt: 0,
          additionalDiscountAmt: 0,
          standardAmt: 0,
          mainPayAmt: 0,
          accumulationPayAmt: 0,
          remainingPgPayAmt: 0,
          payAmt: 0,
        },
      },
      after: {
        delivery: {
          deliveryAmt: 0,
          remoteDeliveryAmt: 0,
          totalDeliveryAmt: 0,
          deliveryGroupAmounts: {
            prepaidRemoteDeliveryAmt: 0,
            payOnRemoteDeliveryAmt: 0,
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            payOnDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            prepaidDeliveryAmt: 0,
            totalPrepaidDeliveryAmt: 0,
            alreadyPaidTotalDeliveryAmt: 0,
          },
        },
        coupon: {
          cartCouponDiscountAmt: 0,
          productCouponDiscountAmt: 0,
        },
        accumulation: {
          accumulationAmt: 0,
        },
        order: {
          immediateDiscountAmt: 0,
          additionalDiscountAmt: 0,
          standardAmt: 0,
          mainPayAmt: 0,
          accumulationPayAmt: 0,
          remainingPgPayAmt: 0,
          payAmt: 0,
        },
      },
      refund: {
        delivery: {
          deliveryAmt: 0,
          remoteDeliveryAmt: 0,
          totalDeliveryAmt: 0,
          deliveryGroupAmounts: {
            prepaidRemoteDeliveryAmt: 0,
            payOnRemoteDeliveryAmt: 0,
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            payOnDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            prepaidDeliveryAmt: 0,
            totalPrepaidDeliveryAmt: 0,
            alreadyPaidTotalDeliveryAmt: 0,
          },
        },
        coupon: {
          cartCouponDiscountAmt: 0,
          productCouponDiscountAmt: 0,
        },
        accumulation: {
          accumulationAmt: 0,
        },
        order: {
          immediateDiscountAmt: 0,
          additionalDiscountAmt: 0,
          standardAmt: 0,
          mainPayAmt: 0,
          accumulationPayAmt: 0,
          remainingPgPayAmt: 0,
          payAmt: 0,
          totalDeliveryAmt: 0,
        },
      },
    },
    overflowsPgAmt: false,
  };
  private objJson = '';
  private responsibleObjectType: string = 'BUYER';
  private refundTypeValue: string = '';
  private claimOrderOptions!: GetClaimsOrderOptionsOrderOptionNoApply;
  private refundTypeDivShow: boolean = true;
  private zeroRefundShow: boolean = false;
  private refundBankInfoTrShow: boolean = true;
  private holdByReservation: boolean = false;
  private escrowOrder: boolean = false;
  private orgChargeDeliveryAmt: boolean = true;
  private getPostReturnPredictRequest(): PostReturnsPredictRequest {
    let postReturnsPredictRequest: PostReturnsPredictRequest = {
      data: {
        responsibleObjectType: 'BUYER',
        refundType: 'PG',
        orderNo: '',
        returnDeliveryProposedAmt: 0,
        sellerPaysClaimedDelivery: false,
        returnWayType: 'SELLER_COLLECT',
        returnOrderOptions: [
          {
            claimCnt: 0,
            orderOptionNo: 0
          }
        ],
        returnAddress: {
          address: '',
          name: '',
          jibunAddress: '',
          detailAddress: '',
          zipCd: '',
          contact1: '',
          contact2: ''
        }
      }
    };

    let orderOptionParams: any = [];
    postReturnsPredictRequest.data.responsibleObjectType = 'BUYER';
    postReturnsPredictRequest.data.refundType = this.orderOptionsApply.payType === 'NAVER_PAY' ? this.findNaverRefundType() : this.orderOptionsApply.refundTypes[0].refundType as RefundType;
    postReturnsPredictRequest.data.orderNo = this.orderOptionsApply.orderNo;
    this.orderOptionsApply.claimableOptions.forEach((item: any) => {
      if(this.escrowOrder) {
        item.checkboxValue = true
        postReturnsPredictRequest.data.responsibleObjectType = 'SELLER';
        postReturnsPredictRequest.data.sellerPaysClaimedDelivery = true;
      }
      if (item.checkboxValue) {
        orderOptionParams.push({
          claimCnt: item.claimedCnt,
          orderOptionNo: item.orderOptionNo
        });
      }
    });
    postReturnsPredictRequest.data.returnOrderOptions = orderOptionParams;
    return postReturnsPredictRequest;
  }

  private findNaverRefundType(): RefundType{
    if(this.orderOptionsApply.payType !== 'NAVER_PAY'){
      return this.orderOptionsApply.refundTypes[0].refundType as RefundType;
    }

    // label은 서버에서 한글로 내려주기 때문에 한글로 비교
    return this.orderOptionsApply.refundTypes.find(({refundType, label}) => refundType==='PG' && label === '네이버페이(주문형)').refundType as RefundType
  }

  private calculateMethod() {
    this.$api.postReturnsPredict(this.getPostReturnPredictRequest()).then((ret: any) => {
      this.showB = true;
      this.postReturnsPredict = ret.data;
      this.postReturnsPredict.amounts.refund.order.totalDeliveryAmt = this.postReturnsPredict.amounts.refund.coupon.cartCouponDiscountAmt - this.postReturnsPredict.amounts.refund.delivery.totalDeliveryAmt;
      this.objJson = JSON.stringify(this.postReturnsPredict);
      if(this.postReturnsPredict.amounts.adjustedAmounts.claimAmt === 0) {
        this.refundTypeDivShow = false;
        this.zeroRefundShow = true;
        this.refundBankInfoTrShow = false;
      }
    });
  }

  public getPayType(payType: string) {
    switch (payType) {
      case 'ACCOUNT':
        return 'ACCOUNT'

      case 'ACCUMULATION':
        return 'ACCUMULATION'

      case 'ZERO_PAY':
        return 'ZERO_REFUND'

      case 'VIRTUAL_ACCOUNT':
      case 'ESCROW_VIRTUAL_ACCOUNT':
        return 'PG';

      default:
        return 'PG';
    }
  }

  private async created() {
    console.log('return');
    let request: GetClaimsOrderOptionsOrderOptionNoApplyRequest = {
      pathParams: {
        orderOptionNo: this.$route.query.orderProductOptionNo.toString()
      },
      params: {
        claimType: 'RETURN'
      }
    };
    await this.$api.getClaimsOrderOptionsOrderOptionNoApply(request).then((ret: any) => {
      this.isShow = true;
      this.claimOrderOptions = ret.data;
      this.refundType = ret.data.refundTypes[0].refundType;

      ret.data.claimableOptions.forEach((item: any) => {
        let claimableOption: ClaimableOption = {
          ...item,
          checkboxValue: item.orderOptionNo === ret.data.claimedOption.orderOptionNo,
          mallOptionNo: item.mallOptionNo,
          userInputText: item.userInputText,
          orderNo: item.orderNo,
          immediateDiscountAmt: item.immediateDiscountAmt,
          salePrice: item.salePrice,
          orderStatusType: item.orderStatusType,
          optionValue: item.optionValue,
          orderCnt: item.orderCnt,
          addPrice: item.addPrice,
          mallProductNo: item.mallProductNo,
          claimedCnt: item.claimedCnt,
          productName: item.productName,
          additionalDiscountAmt: item.additionalDiscountAmt,
          optionName: item.optionName,
          orderOptionNo: item.orderOptionNo,
          partnerNo: Number(ret.data.partnerNo),
          partnerName: ret.data.partnerName,
          payType: ret.data.payType,
          productUrl: item.productUrl,
          usesOption: item.usesOption,
          hasSetOption: item.hasSetOption,
          setOptions: item.setOptions,
          holdByReservation: item.holdByReservation,
          optionManagementCd: item.optionManagementCd
        };
        this.holdByReservation = item.holdByReservation
        this.orderOptionsApply.claimableOptions.push(claimableOption);
      });

      this.orderOptionsApply.refundTypes = ret.data.refundTypes;
      this.orderOptionsApply.payType = ret.data.payType;
      this.orderOptionsApply.orderNo = ret.data.claimedOption.orderNo;
      this.escrowOrder = this.orderOptionsApply.payType.indexOf('ESCROW_REALTIME_ACCOUNT_TRANSFER') >= 0 || this.orderOptionsApply.payType.indexOf('ESCROW_VIRTUAL_ACCOUNT') >= 0
      this.showA = true;

      this.calculateMethod();
    })
    .catch((error: any) => {
      // alert(error.data.message);
      window.opener.location.reload();
      window.close();
    });
  }
  private validationBeforeApply(): boolean {
    if (this.checkHoldByReservation()) {
      return false;
    }
    let needBankAccount = false;

    if((this.$refs.componentRefundExchangeAmount as any).zeroRefundShow) {
      this.refundTypeValue = 'ZERO_REFUND'
    }
    switch (this.refundTypeValue) {
      case 'CASH':
      case 'ACCOUNT':
        needBankAccount = true;
        break;
      case 'PG':
        if(this.orderOptionsApply.payType === 'VIRTUAL_ACCOUNT' || this.orderOptionsApply.payType === 'ESCROW_VIRTUAL_ACCOUNT') {
          needBankAccount = true;
        }
        break;
    }

    if (needBankAccount && (this.$refs.componentRefundExchangeAmount as any).refundBankValue == '') {
      alert(this.$t('CLAIM_RETURNPOPUP_ALERT4'));
      (this.$refs.componentRefundExchangeAmount as any).$refs.refundBank.focus();
      return false;
    }
    if (needBankAccount && (this.$refs.componentRefundExchangeAmount as any).refundBankAccount == '') {
      alert(this.$t('CLAIM_RETURNPOPUP_ALERT5'));
      (this.$refs.componentRefundExchangeAmount as any).$refs.refundBankAccountRef.focus();
      return false;
    }
    if (needBankAccount && (this.$refs.componentRefundExchangeAmount as any).refundBankDepositorName == '') {
      alert(this.$t('CLAIM_RETURNPOPUP_ALERT6'));
      (this.$refs.componentRefundExchangeAmount as any).$refs.refundBankDepositorNameRef.focus();
      return false;
    }
    if ((this.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustAmt > 0 && (this.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustReason == '') {
      alert(this.$t('CLAIM_RETURNPOPUP_ALERT7'));
      (this.$refs.componentReturnShippingFee as any).$refs.returnDeliveryAmtAdjustReasonRef.focus();
      return false;
    }
    //반품주소지 정보 valid
    if(this.postReturnsPredict.shipping.deliveryType !== 'NONE') {
      if ((this.$refs.componentReturnAddress as any).returnName == '') {
        alert(this.$t('CLAIM_RETURNPOPUP_ALERT8'));
        (this.$refs.componentReturnAddress as any).$refs.returnNameRef.focus();
        return false;
      }
      if ((this.$refs.componentReturnAddress as any).returnContact1 == '') {
        alert(this.$t('CLAIM_RETURNPOPUP_ALERT9'));
        (this.$refs.componentReturnAddress as any).$refs.returnContact1Ref.focus();
        return false;
      }
      if ((this.$refs.componentReturnAddress as any).zipCd == '' || (this.$refs.componentReturnAddress as any).address == '') {
        alert(this.$t('CLAIM_RETURNPOPUP_ALERT10'));
        (this.$refs.componentReturnAddress as any).$refs.returnDetailAddress.focus();
        return false;
      }
    }
    return true;
  }

  private checkHoldByReservation(): boolean {
    return this.holdByReservation == true && !confirm(this.$t('CLAIM_CANCELPOPUP_CONFIRM').toString());
  }

  private onClickApplyReturn() {
    if ((this.$refs.componentItemsClaim as any).optionno.length <= 0) {
      alert(this.$t('CLAIM_RETURNPOPUP_ALERT2'));
      return;
    }

    if (((this.$refs.componentRefundExchangeAmount as any).refundTypeValue != 'ACCOUNT' && (this.$refs.componentRefundExchangeAmount as any).refundTypeValue != 'ACCUMULATION') && this.postReturnsPredict.overflowsPgAmt) {
      alert(this.$t('CLAIM_RETURNPOPUP_ALERT3'));
      return;
    }

    if (this.validationBeforeApply() == false) {
      return;
    }

    if(!confirm(this.$t('CLAIM_RETURNPOPUP_CONFIRM') as any)){
      return;
    }

    this.alertMessageForFreeGift();

    let orderOptionParams: any = [];
    for (let i = 0; i < (this.$refs.componentItemsClaim as any).optionno.length; i++) {
      let claimCnt = (this.$refs.componentItemsClaim as any).orderCntMap.get((this.$refs.componentItemsClaim as any).optionno[i]) || 0;

      orderOptionParams.push({
        claimCnt: claimCnt,
        orderOptionNo: (this.$refs.componentItemsClaim as any).optionno[i]
      });
    }

    let bank = '';
    let bankNm = '';
    let refundType;
    if((this.$refs.componentRefundExchangeAmount as any).refundBankEditShow === false) {
      bank = null
      bankNm = null
    } else {
      bank = (this.$refs.componentRefundExchangeAmount as any).refundBankValue;
      (this.$refs.componentRefundExchangeAmount as any).refundBankList.forEach((element: {value: string; name: string}) => {
        if (element.value == (this.$refs.componentRefundExchangeAmount as any).refundBankValue) {
          bankNm = element.name;
        }
      });
    }
    if((this.$refs.componentRefundExchangeAmount as any).claimTotal === 0) {
      refundType = 'ZERO_REFUND'
    } else {
      refundType = (this.$refs.componentRefundExchangeAmount as any).refundTypeValue
    }

    let request: PostReturnsRequest = {
      data: {
        returnDeliveryAmtAdjustReason: (this.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustReason,
        reasonDetail: (this.$refs.componentItemsClaim as any).claimReasonDetail,
        calculateParam: {
          responsibleObjectType: (this.$refs.componentItemsClaim as any).responsibleObjectTypeValue,
          refundType: refundType,
          orderNo: this.orderOptionsApply.orderNo,
          returnDeliveryProposedAmt: (this.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustAmt,
          sellerPaysClaimedDelivery: (this.$refs.componentProductDetails as any).chargeDeliveryAmt,
          returnWayType: (this.$refs.componentReturnAddress as any).returnWayType,
          returnOrderOptions: orderOptionParams,
          returnAddress: {
            address: (this.$refs.componentReturnAddress as any).address,
            name: (this.$refs.componentReturnAddress as any).returnName,
            jibunAddress: (this.$refs.componentReturnAddress as any).returnJibunAddress,
            detailAddress: (this.$refs.componentReturnAddress as any).detailAddress,
            zipCd: (this.$refs.componentReturnAddress as any).zipCd,
            contact1: (this.$refs.componentReturnAddress as any).returnContact1,
            contact2: (this.$refs.componentReturnAddress as any).returnContact2
          }
        },
        deliveryCompanyType: (this.$refs.componentReturnAddress as any).deliveryCompanyType.length ? (this.$refs.componentReturnAddress as any).deliveryCompanyType : null,
        returnDeliveryNote: (this.$refs.componentReturnAddress as any).returnDeliveryNote,
        reasonType: (this.$refs.componentItemsClaim as any).claimReasonType,
        invoiceNo: (this.$refs.componentReturnAddress as any).invocieNo,
        evadesReturnProcess: (this.$refs.componentReturnAddress as any).unApprovedYn,
        refundBankAccount: {
          depositorName: (this.$refs.componentRefundExchangeAmount as any).refundBankDepositorName,
          bank: bank,
          bankName: bankNm,
          account: (this.$refs.componentRefundExchangeAmount as any).refundBankAccount
        }
      }
    };

    this.$api.postReturns(request).then(()=>{
      alert(this.$t('CLAIM_CANCELPOPUP_PROCESS_SUCCESS_MESSAGE'));
      window.opener.location.reload();
      window.close();
    })
  }

  private alertMessageForFreeGift() {

    const hasTargetProduct = this.orderOptionsApply.claimableOptions.some(option => (option as any ).isGivenFreeGift);
    if (hasTargetProduct) {
      alert('사은품이 지급된 대상상품이 포함되어있습니다. \n사은품 지급 철회가 필요한 경우 \n사은품 상품도 클레임 처리해 주세요.');
      return;
    }

    const hasFreeGiftProduct = this.orderOptionsApply.claimableOptions.some(option => (option as any).isFreeGift);
    if (hasFreeGiftProduct) {
      alert('사은품 상품이 포함되어 있습니다. \n사은품 지급 대상상품의 클레임 처리가 필요한 경우 \n별도 처리해 주세요.');
    }
  }

  private beforeReturnDeliveryAmtAdjustAmt: number = 0;
  private returnWayType: string = 'SELLER_COLLECT';

  private setData() {
    if ((this.$refs.componentReturnAddress as any).returnWayType == 'BUYER_DIRECT_RETURN') {
      if ((this.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustAmt != 0) {
        alert(this.$t('CLAIM_RETURNPOPUP_ALERT1'));
      } else {
        if ((this.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustReason != '') {
          alert(this.$t('CLAIM_RETURNPOPUP_ALERT1'));
        }
      }
      (this.$refs.componentReturnShippingFee as any).clearText(0);
    }

    let orderOptionParams: any = [];
    for (let i = 0; i < (this.$refs.componentItemsClaim as any).optionno.length; i++) {
      let claimCnt = (this.$refs.componentItemsClaim as any).orderCntMap.get((this.$refs.componentItemsClaim as any).optionno[i]) || 0;
      orderOptionParams.push({
        claimCnt: claimCnt,
        orderOptionNo: (this.$refs.componentItemsClaim as any).optionno[i]
      });
    }
    let request = {
      data: {
        responsibleObjectType: (this.$refs.componentItemsClaim as any).responsibleObjectTypeValue,
        refundType: (this.$refs.componentRefundExchangeAmount as any).refundTypeValue,
        orderNo: this.orderOptionsApply.orderNo,
        returnDeliveryProposedAmt: (this.$refs.componentReturnShippingFee as any).returnDeliveryAmtAdjustAmt,
        sellerPaysClaimedDelivery: (this.$refs.componentProductDetails as any).chargeDeliveryAmt,
        returnWayType: (this.$refs.componentReturnAddress as any).returnWayType,
        returnOrderOptions: orderOptionParams,
        returnAddress: {
          address: (this.$refs.componentReturnAddress as any).address,
          name: (this.$refs.componentReturnAddress as any).returnName,
          jibunAddress: (this.$refs.componentReturnAddress as any).returnJibunAddress,
          detailAddress: (this.$refs.componentReturnAddress as any).detailAddress,
          zipCd: (this.$refs.componentReturnAddress as any).zipCd,
          contact1: (this.$refs.componentReturnAddress as any).returnContact1,
          contact2: (this.$refs.componentReturnAddress as any).returnContact2,
        }
      }
    };

    if((this.$refs.componentItemsClaim as any).responsibleObjectTypeValue === 'BUYER') {
      request.data.sellerPaysClaimedDelivery = false;
    }

    if (!this.validation(request)) {
      return;
    }

    this.$api.postReturnsPredict(request).then((ret: any) => {
      this.showB = true;
      this.postReturnsPredict = ret.data;
      this.postReturnsPredict.amounts.refund.order.totalDeliveryAmt = this.postReturnsPredict.amounts.refund.coupon.cartCouponDiscountAmt - this.postReturnsPredict.amounts.refund.delivery.totalDeliveryAmt;
      this.objJson = JSON.stringify(this.postReturnsPredict);
      if(this.postReturnsPredict.amounts.adjustedAmounts.claimAmt === 0) {
        this.refundTypeDivShow = false;
        this.zeroRefundShow = true;
        this.refundBankInfoTrShow = false;
      } else {
        this.refundTypeDivShow = true;
        this.zeroRefundShow = false;
        this.refundBankInfoTrShow = true;
      }
      this.refundTypeValue = request.data.refundType;
    });
  }

  private validation(postReturnsPredictRequest: PostReturnsPredictRequest): boolean {
    if (this.postReturnsPredict.amounts.returnDelivery.returnDeliveryAmt < 0 || this.postReturnsPredict.amounts.returnDelivery.returnRemoteDeliveryAmt < 0) {
      if (postReturnsPredictRequest.data.returnDeliveryProposedAmt > 0) {
        alert(this.$t('CLAIM_RETURNPOPUP_ALERT11'));
        (this.$refs.componentReturnShippingFee as any).clearText(this.beforeReturnDeliveryAmtAdjustAmt);
        return false;
      }
    } else if (
      postReturnsPredictRequest.data.returnDeliveryProposedAmt >
      this.postReturnsPredict.amounts.returnDelivery.returnDeliveryAmt + this.postReturnsPredict.amounts.returnDelivery.returnRemoteDeliveryAmt
    ) {
      alert(this.$t('CLAIM_RETURNPOPUP_ALERT11'));
      (this.$refs.componentReturnShippingFee as any).clearText(this.beforeReturnDeliveryAmtAdjustAmt);
      return false;
    }
    this.beforeReturnDeliveryAmtAdjustAmt = postReturnsPredictRequest.data.returnDeliveryProposedAmt;

    if (this.claimOrderOptions.deliveryAddress !== null) {
      if (postReturnsPredictRequest.data.returnAddress.name == '') {
        alert(this.$t('CLAIM_RETURNPOPUP_ALERT12'));
        (this.$refs.componentReturnAddress as any).$refs.returnNameRef.focus();
        return false;
      }
      if (postReturnsPredictRequest.data.returnAddress.contact1 == '') {
        alert(this.$t('CLAIM_RETURNPOPUP_ALERT9'));
        (this.$refs.componentReturnAddress as any).$refs.returnContact1Ref.focus();
        return false;
      }
      if ((this.$refs.componentReturnAddress as any).zipCd == '' || (this.$refs.componentReturnAddress as any).address == '') {
        alert(this.$t('CLAIM_RETURNPOPUP_ALERT10'));
        (this.$refs.componentReturnAddress as any).$refs.returnDetailAddress.focus();
        return false;
      }
    }

    return true;
  }

  public close(): void {
    if (!confirm(this.$t('CLAIM_RETURNPOPUP_CLOSECONFIRM').toString())) {
      return;
    }
    window.close();
  }

  public popupResize(): void {
    let contentWidth = $('#container').width() + 30;
    let contentHeight = $('#container').height() + 76;
    window.resizeTo(contentWidth, contentHeight);
  }

  public mounted() {
    addClass(document.body, 'popup popup_large');
    setTimeout(() => {this.popupResize()},1000)
  }
}
